module.exports = __webpack_public_path__ + "img/联系我们.f947101d.jpg";